    <template>
    <div class="container">
        <div class="row">

            <div class="col-lg-4">
                <h2 class="h h--2 h--dark">Szkolenia stacjonarne</h2>
                <p class="paragraph">Znajdziesz tu aktualne wydarzenia. Wybierz interesującą Cię tematykę oraz termin i zgłoś swoje uczestnictwo.</p>
            </div>
            <div class="col-lg-8">
                <div class="row row-eq-height calendar__row" v-if="events.length > 0">
                    <div class="col-lg-6 calendar__col" v-for="event in events" :key="event.id">
                        <div class="calendar__item" >
                            <div class="calendar__item-date">
                                <b>{{ event.sortDate | formatDate('DD') }}</b><br/>
                                {{ event.sortDate | formatDate('MMMM') }}<br/>
                                {{ event.sortDate | formatDate('YYYY') }}
                            </div>
                            <div class="calendar__item-desc">
                                <p v-if="event.amISignedUp" class="calendar__item-desc-registered">
                                    <img src="../../../assets/img/enlisted.png" class="calendar__item-enlisted" /> jesteś zapisany na to wydarzenie
                                </p>
                                <p class="calendar__item-desc-title"><b>{{ event.title }}</b></p>
                            </div>
                            <div class="calendar__item-link">
                                <router-link :to="{name: 'Training', params: { id: event.object_id }}" v-if="event.object_type!='App\\CalendarHolidayDate'">&raquo;</router-link>
                                <a :href="event.external_url" v-else target="_blank">&raquo;</a>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="profile" v-if="events.length == 0">
                    <p>brak wydarzeń</p>
                </div>
            </div>
        </div>

        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
    import Vue from 'vue'
    import moment from 'moment'

    export default {
        name: 'StationaryTrainingComponent',
        data () {
            return {
                events: []
            }
        },
        beforeRouteEnter(to, from, next) {
            Vue.axios({
                method: 'get',
                url: '/users/dates'
            })
            .then((datesResponse) => {
                next(vm => {
                    vm.events = datesResponse.data.data.dates.filter(function(e) {
                        return (e.active 
                            && (!e.show_start || vm.checkDateEvent(e.show_start)) 
                            && e.title != 'Wypożyczenie narzędzi'
                            )
                    });
                });
            })
            .catch(error => next(false))
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        mounted: function() {
            if(!this.user || this.user.id != 1 ) {
                this.$gtag.pageview({
                    page_path: '/szkolenia-stacjonarne',
                })
            }
        },
        methods: {
            checkDateEvent(start) {
                return moment(moment().format('YYYY.MM.DD HH:mm')).isAfter(moment(start, 'YYYY.MM.DD HH:mm'));
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/calendar/StationaryTrainingComponent.vue